import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'utilities',
    lazy: async () => ({ Component: (await import('./UtilitiesPage')).UtilitiesPage }),
  },
];
